<template>
    <div>
        <input id="formulario" v-model="buscar" :title="buscar" v-on:keyup.enter="buscarDatos()" type="search">
    </div>
</template>

<script>
import app from '../App'
export default {
  name: 'buscador',
  props: ['arrayCriptoOriginal', 'arrayCripto'],
  data () {
    return {
      buscar: '',
      app
    }
  },
  methods: {
    buscarDatos () {
      let datos = this.items()
      this.$emit('tengo_resultados', datos)
    },
    items () {
      if (this.buscar === '') {
        return this.arrayCriptoOriginal
      }
      return this.arrayCriptoOriginal.filter(item => {
        return item.mainSymbol.toLowerCase().includes(this.buscar.toLowerCase())
      })
    }
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/buscador.vue